module.exports = __webpack_public_path__ + "static/media/400055_01.5bf457ec.png";